<nav aria-label="Breadcrumb" class="my-2 ml-3">
  <ol class="flex flex-wrap items-center gap-1.5 text-sm">
    <li class="flex items-center">
      <a
        routerLink="/dashboard"
        aria-label="Dashboard"
        class="flex h-7 w-7 items-center justify-center rounded-md text-[#375e94] transition-colors hover:bg-[#375e94]/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#375e94]/40">
        <fa-icon [icon]="faHouseChimney" />
      </a>
    </li>
    @for (breadcrumb of navigations; track $index) {
      <li class="flex min-w-0 items-center gap-1.5">
        <fa-icon [icon]="faAngleRight" class="text-xs text-[#919EAB]" aria-hidden="true" />
        <button
          type="button"
          (click)="navToRoute(breadcrumb.route, breadcrumb.queryParams)"
          [title]="breadcrumb.text"
          class="max-w-[16rem] truncate rounded-md px-1.5 py-0.5 font-medium text-[#637381] transition-colors hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#375e94]/40">
          {{ breadcrumb.text }}
        </button>
      </li>
    }
    @if (endText) {
      <li class="flex min-w-0 items-center gap-1.5">
        <fa-icon [icon]="faAngleRight" class="text-xs text-[#919EAB]" aria-hidden="true" />
        <span aria-current="page" [title]="endText" class="max-w-[20rem] truncate px-1.5 py-0.5 font-semibold text-gray-900">
          {{ endText }}
        </span>
      </li>
    }
  </ol>
</nav>
